"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSlider = void 0;
const react_1 = __importDefault(require("react"));
const Slider_1 = __importDefault(require("@mui/material/Slider"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const useStyles = makeStyles_1.default({
    root: {
        height: 3,
        padding: '13px 0px',
        color: '#fa9732',
    },
    thumb: {
        height: 27,
        width: 27,
        backgroundColor: '#fff',
        border: '1px solid #fa9732',
        marginTop: -12,
        boxShadow: '#ebebeb 0px 2px 2px',
        '&:focus,&:hover,&$active': {
            boxShadow: '#ccc 0px 2px 3px 1px',
        },
        '& .bar': {
            height: 9,
            width: 1,
            backgroundColor: 'currentColor',
            marginLeft: 1,
            marginRight: 1,
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 3,
    },
    rail: {
        color: '#d8d8d8',
        opacity: 1,
        height: 3,
    },
});
exports.RangeSlider = ({ selectedRange, label, onChange, limitRange }) => {
    const classes = useStyles({});
    const handleChange = (_event, newValue) => {
        onChange({ min: newValue[0], max: newValue[1] });
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(Typography_1.default, { id: "range-slider", gutterBottom: true }, label),
        react_1.default.createElement(Slider_1.default, { value: [selectedRange.min, selectedRange.max], onChange: handleChange, max: limitRange.max, min: limitRange.min, valueLabelDisplay: "auto", "aria-labelledby": "range-slider" })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmFuZ2VTbGlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SYW5nZVNsaWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7Ozs7O0FBRUgsa0RBQTBCO0FBQzFCLGtFQUEwQztBQUMxQywwRUFBa0Q7QUFDbEQsd0VBQWdEO0FBRWhELE1BQU0sU0FBUyxHQUFHLG9CQUFVLENBQUM7SUFDM0IsSUFBSSxFQUFFO1FBQ0osTUFBTSxFQUFFLENBQUM7UUFDVCxPQUFPLEVBQUUsVUFBVTtRQUNuQixLQUFLLEVBQUUsU0FBUztLQUNqQjtJQUNELEtBQUssRUFBRTtRQUNMLE1BQU0sRUFBRSxFQUFFO1FBQ1YsS0FBSyxFQUFFLEVBQUU7UUFDVCxlQUFlLEVBQUUsTUFBTTtRQUN2QixNQUFNLEVBQUUsbUJBQW1CO1FBQzNCLFNBQVMsRUFBRSxDQUFDLEVBQUU7UUFDZCxTQUFTLEVBQUUscUJBQXFCO1FBQ2hDLDBCQUEwQixFQUFFO1lBQzFCLFNBQVMsRUFBRSxzQkFBc0I7U0FDbEM7UUFDRCxRQUFRLEVBQUU7WUFDUixNQUFNLEVBQUUsQ0FBQztZQUNULEtBQUssRUFBRSxDQUFDO1lBQ1IsZUFBZSxFQUFFLGNBQWM7WUFDL0IsVUFBVSxFQUFFLENBQUM7WUFDYixXQUFXLEVBQUUsQ0FBQztTQUNmO0tBQ0Y7SUFDRCxNQUFNLEVBQUUsRUFBRTtJQUNWLFVBQVUsRUFBRTtRQUNWLElBQUksRUFBRSxrQkFBa0I7S0FDekI7SUFDRCxLQUFLLEVBQUU7UUFDTCxNQUFNLEVBQUUsQ0FBQztLQUNWO0lBQ0QsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFNBQVM7UUFDaEIsT0FBTyxFQUFFLENBQUM7UUFDVixNQUFNLEVBQUUsQ0FBQztLQUNWO0NBQ0YsQ0FBQyxDQUFDO0FBY1UsUUFBQSxXQUFXLEdBQUcsQ0FBQyxFQUFFLGFBQWEsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLFVBQVUsRUFBcUIsRUFBRSxFQUFFO0lBQy9GLE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUU5QixNQUFNLFlBQVksR0FBRyxDQUFDLE1BQVcsRUFBRSxRQUEyQixFQUFFLEVBQUU7UUFDaEUsUUFBUSxDQUFDLEVBQUUsR0FBRyxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUNuRCxDQUFDLENBQUM7SUFFRixPQUFPLENBQ0wsdUNBQUssU0FBUyxFQUFFLE9BQU8sQ0FBQyxJQUFJO1FBQzFCLDhCQUFDLG9CQUFVLElBQUMsRUFBRSxFQUFDLGNBQWMsRUFBQyxZQUFZLFVBQ3ZDLEtBQUssQ0FDSztRQUNiLDhCQUFDLGdCQUFNLElBQ0wsS0FBSyxFQUFFLENBQUMsYUFBYSxDQUFDLEdBQUcsRUFBRSxhQUFhLENBQUMsR0FBRyxDQUFDLEVBQzdDLFFBQVEsRUFBRSxZQUFZLEVBQ3RCLEdBQUcsRUFBRSxVQUFVLENBQUMsR0FBRyxFQUNuQixHQUFHLEVBQUUsVUFBVSxDQUFDLEdBQUcsRUFDbkIsaUJBQWlCLEVBQUMsTUFBTSxxQkFDUixjQUFjLEdBQzlCLENBQ0UsQ0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDIn0=